var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2105_11045",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 26,
    height: 26,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2105_11045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_2",
    d: "M13.0007 13.0003C13.5965 13.0003 14.1066 12.7882 14.5309 12.3639C14.9552 11.9396 15.1673 11.4295 15.1673 10.8337C15.1673 10.2378 14.9552 9.72776 14.5309 9.30345C14.1066 8.87914 13.5965 8.66699 13.0007 8.66699C12.4048 8.66699 11.8947 8.87914 11.4704 9.30345C11.0461 9.72776 10.834 10.2378 10.834 10.8337C10.834 11.4295 11.0461 11.9396 11.4704 12.3639C11.8947 12.7882 12.4048 13.0003 13.0007 13.0003ZM13.0007 20.9628C15.2034 18.9406 16.8375 17.1034 17.9027 15.4514C18.968 13.7993 19.5007 12.3323 19.5007 11.0503C19.5007 9.08227 18.8732 7.47081 17.6184 6.21595C16.3635 4.96109 14.8243 4.33366 13.0007 4.33366C11.177 4.33366 9.6378 4.96109 8.38294 6.21595C7.12808 7.47081 6.50065 9.08227 6.50065 11.0503C6.50065 12.3323 7.03329 13.7993 8.09857 15.4514C9.16385 17.1034 10.7979 18.9406 13.0007 20.9628ZM13.0007 23.8337C10.0937 21.36 7.92253 19.0625 6.48711 16.9409C5.05169 14.8194 4.33398 12.8559 4.33398 11.0503C4.33398 8.34199 5.20516 6.18435 6.94753 4.57741C8.68989 2.97046 10.7076 2.16699 13.0007 2.16699C15.2937 2.16699 17.3114 2.97046 19.0538 4.57741C20.7961 6.18435 21.6673 8.34199 21.6673 11.0503C21.6673 12.8559 20.9496 14.8194 19.5142 16.9409C18.0788 19.0625 15.9076 21.36 13.0007 23.8337Z",
    fill: "url(#paint0_linear_2105_11045)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2105_11045",
    x1: 13.0007,
    y1: 2.16699,
    x2: 13.0007,
    y2: 23.8337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.9d1fd730b95b7d487774079006aea550.svg";
export { ForwardRef as ReactComponent };